import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { lazyImport } from '@common/hocs/lazyImport';
import { asyncWrapper } from '@common/hocs/asyncWrapper';
import { askForTerminalUsageConfirmationIfRequired } from '@app/dev/helpers/terminalUsageConfirmation';

const Admin = asyncWrapper(lazyImport(() => import('@admin')));

const AdminWrapper = (props) => {
  const { startupSettings } = useSelector((state) => state.terminal);

  useEffect(() => (
    () => {
      // on admin page close
      askForTerminalUsageConfirmationIfRequired();
    }
  ), []);

  return <Admin {...props} startupSettings={startupSettings} />;
};

export default AdminWrapper;
